import React from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';
import Suspense from '@atlaskit/react-ufo/suspense';
import { useAgentUrlActions } from '@atlassian/conversation-assistant-agent/controllers/agent-url-actions';
import { AsyncRovoAgentDebugModal } from '@atlassian/rovo-agent-debug-modal/async';

import { useGlobalConfig } from '../../common/utils/global-config/useGlobalConfig';
import { useAssistanceServiceParams } from '../../common/utils/use-assistance-service-params';
import { useAgentDebugModal } from '../../controllers/agent-debug-modal/useAgentDebugModal';
import { useAgentDebugLogsService } from '../../services/use-agent-debug-logs';

export const AgentDebugModal = (): React.JSX.Element => {
	const assistanceServiceParams = useAssistanceServiceParams({
		touchpointSource: 'debug-modal-contents',
	});

	const { siteId } = useGlobalConfig();
	const [{ isOpen, data }, { closeModal }] = useAgentDebugModal();
	const debugLogsService = useAgentDebugLogsService({
		conversationId: data?.conversationId ?? '',
		messageId: data?.messageId ?? '',
		assistanceServiceParams,
	});

	const { onViewAgentFullProfile } = useAgentUrlActions({
		siteId,
		source: 'chat-header',
	});

	return (
		<Suspense interactionName="conversation-assistant-agent-debug-modal-suspense" fallback={<></>}>
			<ModalTransition>
				{isOpen && (
					<AsyncRovoAgentDebugModal
						source="ai-mate-conversation-assistant-debug-modal"
						debugLogService={debugLogsService}
						onViewAgent={(authorId: string) => onViewAgentFullProfile(authorId)}
						onClose={closeModal}
					/>
				)}
			</ModalTransition>
		</Suspense>
	);
};
